import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '../common';
import type { SubscriptionExtras } from './types';

type Variables = { period: string; carId: number };
type Response = SubscriptionExtras;

export const useSubscriptionExtras = createQuery<
  Response,
  Variables,
  AxiosError
>({
  queryKey: ['subscriptionExtras'],
  fetcher: ({ period, carId }) => {
    return client
      .get(`v2/subscriptions/extras?period=${period}&car_id=${carId}`)
      .then((response) => {
        return response.data.data;
      });
  },
});
